import React from 'react';
import { Highlight, Prism, themes } from 'prism-react-renderer';
import Copy from '../Copy/Copy';
import normalize from './normalizeFetchCodeBlock';
import { getParams } from '../../utils/highlight';
import './extendPrism';

import './CodeBlock.scss';
import { CodeBlockProps } from '../../entities/CodeEntities';
import InfoBanner from '../InfoBanner/InfoBanner';

export default function FetchCodeBlock(props: CodeBlockProps) {
  //URL e.g: 'https://github.com/arduino-libraries/USBHostGiga/blob/master/examples/KeyboardGiga/KeyboardGiga.ino'
  const { url, className } = props;
  const [language] = getParams(className);
  const [highlights] = normalize(className);

  const [code, setCode] = React.useState<any>('');
  const [fetchError, setFetchError] = React.useState(null);

  React.useEffect(() => {
    fetch(url?.replace('github.com', 'raw.githubusercontent.com').replace('/blob/', '/'))
      .then((response) => (response.ok ? response.text() : setFetchError('Could not load source code')))
      .then(setCode)
      .catch(setFetchError);
  }, [url]);

  if (fetchError) return <div className="error-alert">{fetchError}</div>;

  return (
    <>
      <InfoBanner title={`Code Source on <a href=${url}> Github</a>`} />
      <Highlight code={code} language={language} theme={themes.vsLight} prism={Prism}>
        {({ tokens, getLineProps, getTokenProps, style }) => (
          <div className="gatsby-highlight fetchCodeBlock">
            <Copy content={code} />
            <pre className="pre" style={{ ...style }}>
              <code className={className}>
                {tokens.map((line, i) => {
                  const lineProps = getLineProps({ line, key: i });
                  const className = [lineProps.className]
                    .concat(highlights[i] && `gatsby-highlight-code-line`)
                    .filter(Boolean)
                    .join(` `);
                  return (
                    <div
                      key={i}
                      {...Object.assign({}, lineProps, {
                        className,
                      })}
                    >
                      <span className="line-number">{i + 1}</span>
                      <span className="line-content">
                        {line.map((token, key) => (
                          <span key={key} {...getTokenProps({ token, key })} />
                        ))}
                      </span>
                    </div>
                  );
                })}
              </code>
            </pre>
          </div>
        )}
      </Highlight>
    </>
  );
}
